import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AuthService from '../../../Services/authService';

export default class TpEvaluatorLinkSearchParams extends SearchParamsBase {
  constructor(tpEvaluatorId) {
    super();
    this.initialize(tpEvaluatorId);
  }

  initialize(tpEvaluatorId) {
    this.TpEvaluatorId = tpEvaluatorId || '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'TpEvaluatorId',
      label: 'TpEvaluatorId',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpEvaluatorLinkSearchParams';

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user.officeId;
  }

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
